import { FC, SVGAttributes } from "react";

interface Props {
  colors?: string[];
  width?: number;
}

const IdealIcon: FC<SVGAttributes<SVGSVGElement> & Props> = ({
  colors = ["#fff", "#D52472", "#0A0B09", "#FFFFFE"],
  width = 96,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height="40"
    viewBox={`0 0 ${width} 40`}
    {...props}
  >
    <defs>
      <path
        id="prefix__ideal_a"
        d="M0.824 0.887L6.338 0.887 6.338 10.042 0.824 10.042z"
      />
      <path
        id="prefix__ideal_c"
        d="M3.633.189c1.724 0 3.121 1.397 3.121 3.12 0 1.724-1.397 3.122-3.12 3.122C1.91 6.431.511 5.033.511 3.31.512 1.586 1.91.189 3.633.189z"
      />
      <path
        id="prefix__ideal_e"
        d="M19.78.001c4.165.075 7.684 1.28 10.19 3.507 1.423 1.265 2.522 2.853 3.265 4.722.777 1.953 1.17 4.231 1.17 6.77 0 5.314-1.497 9.282-4.451 11.795-2.343 1.993-5.609 3.063-9.714 3.19l-.46.01v.002H0V0h19.78zm-.373 1.993H1.992v26.014h17.415c8.752 0 13.006-4.255 13.006-13.007 0-4.417-1.267-7.782-3.767-10.003-2.21-1.966-5.406-3.004-9.24-3.004z"
      />
      <path
        id="prefix__ideal_g"
        d="M7.58.42c5.832 0 12.04 2.301 12.04 10.844 0 9.032-6.208 10.788-12.04 10.788H.87V.419h6.71z"
      />
      <path
        id="prefix__ideal_i"
        d="M2.584.004c.433 0 .763.033.99.099.305.09.567.25.784.48.218.229.384.51.497.843.114.332.17.742.17 1.23 0 .428-.053.797-.16 1.108-.13.378-.315.685-.556.92-.182.177-.429.315-.739.415-.231.073-.541.11-.93.11H.665V.004h1.92zm-.398.882h-.473v3.44H2.5c.294 0 .506-.016.636-.05.171-.042.313-.114.426-.215.112-.102.204-.27.275-.502.071-.232.107-.55.107-.951 0-.402-.035-.71-.107-.925-.07-.215-.17-.383-.299-.503-.128-.12-.29-.202-.487-.245-.147-.033-.435-.05-.865-.05z"
      />
      <path
        id="prefix__ideal_k"
        d="M2.584.861c.45 0 .788.035 1.03.105.328.097.613.271.848.518.23.244.408.545.528.896.118.345.178.775.178 1.276 0 .442-.056.83-.167 1.154-.137.398-.337.726-.593.975-.197.192-.464.343-.795.45-.244.077-.572.116-.972.116H.52V.861h2.063zm0 .285H.806v4.92h1.835c.371 0 .67-.034.886-.103.287-.092.517-.22.683-.382.224-.217.4-.508.521-.864.101-.293.152-.65.152-1.061 0-.47-.054-.868-.162-1.184-.107-.312-.263-.578-.466-.792-.2-.21-.442-.358-.72-.44-.214-.063-.534-.094-.951-.094z"
      />
      <path
        id="prefix__ideal_m"
        d="M1.186.744c.444 0 .737.017.895.052.222.048.408.142.555.28.145.137.258.326.336.562.077.232.114.55.114.97 0 .42-.037.744-.113.993-.08.26-.183.445-.316.565-.13.117-.293.2-.486.249-.143.036-.363.054-.671.054H.57V.744h.615zm0 .284h-.33v3.156H1.5c.28 0 .483-.015.602-.045.147-.037.27-.099.364-.184.093-.084.172-.23.235-.437.067-.218.1-.525.1-.91s-.033-.68-.099-.88c-.063-.191-.151-.34-.261-.444-.108-.102-.25-.173-.421-.21-.094-.02-.315-.046-.834-.046z"
      />
      <path
        id="prefix__ideal_o"
        d="M4.066 0.004L4.066 0.886 1.263 0.886 1.263 2.039 3.871 2.039 3.871 2.921 1.263 2.921 1.263 4.326 4.166 4.326 4.166 5.209 0.213 5.209 0.213 0.004z"
      />
      <path
        id="prefix__ideal_q"
        d="M4.209.861v1.167H1.405v.868h2.608v1.167H1.405v1.121h2.903v1.167H.071V.861h4.138zm-.285.285H.356v4.92h3.668V5.47H1.12v-1.69h2.608V3.18H1.12V1.744h2.804v-.598z"
      />
      <path
        id="prefix__ideal_s"
        d="M3.962.004l2.082 5.205H4.9l-.454-1.182h-2.08l-.43 1.182H.82L2.843.004h1.12zm-.57 1.213l-.704 1.928h1.42l-.717-1.928z"
      />
      <path
        id="prefix__ideal_u"
        d="M4.058.861l2.196 5.49H4.803L4.348 5.17H2.466l-.43 1.181H.612L2.746.861h1.312zm-.192.285H2.94l-1.912 4.92h.807l.431-1.18h2.277l.454 1.18h.836l-1.968-4.92z"
      />
      <path
        id="prefix__ideal_w"
        d="M1.39.805l.924 2.482H.484L1.39.805zm.003.824L.892 3.003h1.012l-.511-1.375z"
      />
      <path
        id="prefix__ideal_y"
        d="M1.971 0.046L1.971 4.326 4.586 4.326 4.586 5.209 0.922 5.209 0.922 0.046z"
      />
      <path
        id="prefix__ideal_A"
        d="M2.114.904v4.28h2.615v1.167H.779V.904h1.335zm-.285.285h-.765v4.877h3.38V5.47H1.829v-4.28z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(32 5)">
      <g transform="translate(3 16)">
        <mask id="prefix__ideal_b" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_a" />
        </mask>
        <path
          fill={colors[2]}
          d="M-4.176 -4.113L11.338 -4.113 11.338 15.042 -4.176 15.042z"
          mask="url(#prefix__ideal_b)"
        />
      </g>
      <g transform="translate(3 9)">
        <mask id="prefix__ideal_d" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_c" />
        </mask>
        <path
          fill={colors[2]}
          d="M-4.488 -4.811L11.754 -4.811 11.754 11.431 -4.488 11.431z"
          mask="url(#prefix__ideal_d)"
        />
      </g>
      <mask id="prefix__ideal_f" fill={colors[0]}>
        <use xlinkHref="#prefix__ideal_e" />
      </mask>
      <path
        fill={colors[2]}
        d="M-5 -4.999L39.406 -4.999 39.406 35 -5 35z"
        mask="url(#prefix__ideal_f)"
      />
      <g transform="translate(11 4)">
        <mask id="prefix__ideal_h" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_g" />
        </mask>
        <path
          fill={colors[1]}
          d="M-4.131 -4.581L24.62 -4.581 24.62 27.052 -4.131 27.052z"
          mask="url(#prefix__ideal_h)"
        />
      </g>
      <g transform="translate(10 10)">
        <mask id="prefix__ideal_j" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_i" />
        </mask>
        <path
          fill={colors[3]}
          d="M-4.336 -4.996L10.026 -4.996 10.026 10.209 -4.336 10.209z"
          mask="url(#prefix__ideal_j)"
        />
      </g>
      <g transform="translate(10 9)">
        <mask id="prefix__ideal_l" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_k" />
        </mask>
        <path
          fill={colors[3]}
          d="M-4.479 -4.139L10.168 -4.139 10.168 11.351 -4.479 11.351z"
          mask="url(#prefix__ideal_l)"
        />
      </g>
      <g transform="translate(11 10)">
        <mask id="prefix__ideal_n" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_m" />
        </mask>
        <path
          fill={colors[3]}
          d="M-4.429 -4.256L8.086 -4.256 8.086 9.469 -4.429 9.469z"
          mask="url(#prefix__ideal_n)"
        />
      </g>
      <g transform="translate(16 10)">
        <mask id="prefix__ideal_p" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_o" />
        </mask>
        <path
          fill={colors[3]}
          d="M-4.787 -4.996L9.166 -4.996 9.166 10.209 -4.787 10.209z"
          mask="url(#prefix__ideal_p)"
        />
      </g>
      <g transform="translate(16 9)">
        <mask id="prefix__ideal_r" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_q" />
        </mask>
        <path
          fill={colors[3]}
          d="M-4.929 -4.139L9.308 -4.139 9.308 11.351 -4.929 11.351z"
          mask="url(#prefix__ideal_r)"
        />
      </g>
      <g transform="translate(20 10)">
        <mask id="prefix__ideal_t" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_s" />
        </mask>
        <path
          fill={colors[3]}
          d="M-4.179 -4.996L11.044 -4.996 11.044 10.209 -4.179 10.209z"
          mask="url(#prefix__ideal_t)"
        />
      </g>
      <g transform="translate(20 9)">
        <mask id="prefix__ideal_v" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_u" />
        </mask>
        <path
          fill={colors[3]}
          d="M-4.387 -4.139L11.254 -4.139 11.254 11.351 -4.387 11.351z"
          mask="url(#prefix__ideal_v)"
        />
      </g>
      <g transform="translate(22 10)">
        <mask id="prefix__ideal_x" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_w" />
        </mask>
        <path
          fill={colors[3]}
          d="M-4.515 -4.195L7.314 -4.195 7.314 8.287 -4.515 8.287z"
          mask="url(#prefix__ideal_x)"
        />
      </g>
      <g transform="translate(26 10)">
        <mask id="prefix__ideal_z" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_y" />
        </mask>
        <path
          fill={colors[3]}
          d="M-4.078 -4.954L9.586 -4.954 9.586 10.209 -4.078 10.209z"
          mask="url(#prefix__ideal_z)"
        />
      </g>
      <g transform="translate(26 9)">
        <mask id="prefix__ideal_B" fill={colors[0]}>
          <use xlinkHref="#prefix__ideal_A" />
        </mask>
        <path
          fill={colors[3]}
          d="M-4.221 -4.096L9.729 -4.096 9.729 11.351 -4.221 11.351z"
          mask="url(#prefix__ideal_B)"
        />
      </g>
    </g>
  </svg>
);

export { IdealIcon };
